import React, { useEffect, useState } from 'react'
import { Link } from "react-router-dom"
import { Menu, X } from 'lucide-react';
import image_house from '../../assets/resources/custom/navbar_icons/house.png'
import image_house_darkTheme from '../../assets/resources/custom/navbar_icons/house_darkTheme.png'
import image_chatbot from '../../assets/resources/custom/navbar_icons/chatbot.png'
import image_chatbot_darkTheme from '../../assets/resources/custom/navbar_icons/chatbot_darkTheme.png'
import image_bible from '../../assets/resources/custom/navbar_icons/bible.png'
import image_bible_darkTheme from '../../assets/resources/custom/navbar_icons/bible_darkTheme.png'
import image_sources from '../../assets/resources/custom/navbar_icons/sources.png'
import image_sources_darkTheme from '../../assets/resources/custom/navbar_icons/sources_darkTheme.png'
import image_englishFlag from '../../assets/resources/custom/navbar_icons/england.png'
import image_englishFlag_darkTheme from '../../assets/resources/custom/navbar_icons/england_darkTheme.png'
import image_frenchFlag from '../../assets/resources/custom/navbar_icons/france.png'
import image_profil from '../../assets/resources/custom/navbar_icons/profil.png'
import image_profil_darkTheme from '../../assets/resources/custom/navbar_icons/profil_darkTheme.png'
import image_manage from '../../assets/resources/custom/navbar_icons/manage.png'
import image_manage_darkTheme from '../../assets/resources/custom/navbar_icons/manage_darkTheme.png'
import GetHtmlStrLocalized from '../../datas/GetHtmlStrLocalized'
import GetStrLocalized from '../../datas/GetStrLocalized'
import { HcContext, SizeOfWindow } from '../../types/hccontext'

interface HCNavBarProps {
    language: string;
    setLanguage: React.Dispatch<React.SetStateAction<string>>;
    hcContext: HcContext;
    className: string;
    style?: React.CSSProperties;
}

const HCNavBar: React.FC<HCNavBarProps> = ({ language, setLanguage, hcContext, className, style }) => {

    const [navEltsClass, setNavEltsClass] = useState("");
    const otherLanguage = (language === "fr") ? "en" : "fr";
    let image_otherLanguageFlag;
    if (language === "fr") {
        image_otherLanguageFlag = hcContext.isDarkTheme ? image_englishFlag_darkTheme : image_englishFlag;
    } else {
        image_otherLanguageFlag = image_frenchFlag;
    }

    function showOrHideTexts() {
        if (hcContext.userWantsNavOpen || hcContext.sizeOfWindow === SizeOfWindow.VERY_WIDE) {
            setNavEltsClass("");
        }
        else {
            setNavEltsClass("hc-sidebar-text");
        }
    }

    useEffect(() => {
        showOrHideTexts();
    }, [hcContext.userWantsNavOpen, hcContext.sizeOfWindow]);

    // This adds 'display: block' to fix the newline issue
    // and brings in the other styles from your original CSS.
    const linkStyle: React.CSSProperties = {
        display: 'block', // This is the fix
        paddingTop: '7px',
        paddingBottom: '7px',
        textDecoration: 'none',
        fontSize: '17px',
        color: hcContext.getTextColor(),
    };

    const onMouseOver = () => {
        console.log("on onMouseOver")
    }

    const onMouseOut = () => {
        console.log("on onMouseOut")
    }

    const onMouseEnter = () => {
        if (hcContext.sizeOfWindow !== SizeOfWindow.VERY_SHORT)
            hcContext.setUserWantsIsNavOpen(true);
    }

    const onMouseLeave = () => {
        if (hcContext.sizeOfWindow !== SizeOfWindow.VERY_SHORT)
            hcContext.setUserWantsIsNavOpen(false);
    }
    return (
        <>
            <div
                className={`${className} ${hcContext.getBackgroundColorClass()}`}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                style={style}
            >
                {hcContext.sizeOfWindow != SizeOfWindow.VERY_WIDE && (
                    <button
                        onClick={() => hcContext.setUserWantsIsNavOpen(!hcContext.userWantsNavOpen)}
                        style={{
                            position: 'fixed',
                            left: '7px',
                            top: '40px',
                            transform: 'translateY(-50%)',
                            backgroundColor: 'rgba(0, 0, 0, 0.4)',
                            color: 'white',
                            padding: '0.75rem',
                            borderRadius: '9999px',
                            zIndex: 25,
                            border: 'none',
                            cursor: 'pointer'
                        }}
                        title={!hcContext.userWantsNavOpen ? GetStrLocalized(language, "openMenu") : GetStrLocalized(language, "closeMenu")}
                    >
                        {
                            !hcContext.userWantsNavOpen ?
                                <Menu size={25} />
                                :
                                <X size={25} />
                        }
                    </button>
                )}

                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    height: '40px',
                    zIndex: 30,
                }}>
                    <Link style={{
                        outline: 0,
                        position: 'fixed',
                        top: '17px',
                        left: hcContext.sizeOfWindow != SizeOfWindow.VERY_WIDE ? '90px' : '17px',
                    }} to={"/" + language} onClick={() => hcContext.setUserWantsIsNavOpen(false)}>
                        <img title="Holy Chatter" src="/upload/holy_chatter_logo.png" alt="Holy Chatter logo" className="hc-main-logo hc-not-selectable" />
                    </Link>
                </div>

                <div>
                    <div style={{ height: '80px' }}></div>
                    <Link to={"/" + language} style={linkStyle} onClick={() => hcContext.setUserWantsIsNavOpen(false)}>
                        <img style={{ marginLeft: 20 }} width='20px' src={hcContext.isDarkTheme ? image_house_darkTheme : image_house} alt="home" />
                        <span style={{ marginLeft: 20 }} className={navEltsClass}><GetHtmlStrLocalized language={language} textId="home" /></span>
                    </Link>
                    <Link to={"/" + language + "/" + GetStrLocalized(language, "categoriesFolderName") + "/" + GetStrLocalized(language, "reasonsToBelieveFolderName")} style={linkStyle} onClick={() => hcContext.setUserWantsIsNavOpen(false)}>
                        <img style={{ marginLeft: 20 }} width='20px' src={hcContext.isDarkTheme ? image_house_darkTheme : image_house} alt="home" />
                        <span style={{ marginLeft: 20 }} className={navEltsClass}><GetHtmlStrLocalized language={language} textId="reasonsToBelieve" /></span>
                    </Link>
                    <Link to={"/" + language + "/" + GetStrLocalized(language, "chatbotFolderName")} style={linkStyle} onClick={() => hcContext.setUserWantsIsNavOpen(false)}>
                        <img style={{ marginLeft: 20 }} width='20px' src={hcContext.isDarkTheme ? image_chatbot_darkTheme : image_chatbot} alt="chatbot" />
                        <span style={{ marginLeft: 20 }} className={navEltsClass}><GetHtmlStrLocalized language={language} textId="chatbot" /></span>
                    </Link>
                    <Link to={"/" + language + "/" + GetStrLocalized(language, "readingsFolderName") + "/" + GetStrLocalized(language, "bibleFolderName")} style={linkStyle} onClick={() => hcContext.setUserWantsIsNavOpen(false)}>
                        <img style={{ marginLeft: 20 }} width='20px' src={hcContext.isDarkTheme ? image_bible_darkTheme : image_bible} alt="Bible" />
                        <span style={{ marginLeft: 20 }} className={navEltsClass}><GetHtmlStrLocalized language={language} textId="bible" /></span>
                    </Link>
                    <Link to={"/" + language + "/" + GetStrLocalized(language, "readingsFolderName") + "/" + GetStrLocalized(language, "bibleFolderName") + "/" + GetStrLocalized(language, "gospelsFolderName")} style={linkStyle} onClick={() => hcContext.setUserWantsIsNavOpen(false)}>
                        <img style={{ marginLeft: 20 }} width='20px' src={hcContext.isDarkTheme ? image_bible_darkTheme : image_bible} alt="Bible" />
                        <span style={{ marginLeft: 20 }} className={navEltsClass}><GetHtmlStrLocalized language={language} textId="gospels" /></span>
                    </Link>
                    <Link to={"/" + language + "/" + GetStrLocalized(language, "gospelOfTheDayFolderName")} style={linkStyle} onClick={() => hcContext.setUserWantsIsNavOpen(false)}>
                        <img style={{ marginLeft: 20 }} width='20px' src={hcContext.isDarkTheme ? image_bible_darkTheme : image_bible} alt="Bible" />
                        <span style={{ marginLeft: 20 }} className={navEltsClass}><GetHtmlStrLocalized language={language} textId="gospelOfTheDay" /></span>
                    </Link>
                    <Link to={"/" + language + "/" + GetStrLocalized(language, "readingsOfTheDayFolderName")} style={linkStyle} onClick={() => hcContext.setUserWantsIsNavOpen(false)}>
                        <img style={{ marginLeft: 20 }} width='20px' src={hcContext.isDarkTheme ? image_bible_darkTheme : image_bible} alt="Bible" />
                        <span style={{ marginLeft: 20 }} className={navEltsClass}><GetHtmlStrLocalized language={language} textId="readingsOfTheDay" /></span>
                    </Link>
                    <Link to={"/" + language + "/" + GetStrLocalized(language, "readingsFolderName") + "/" + GetStrLocalized(language, "catechismOfTheCatholicChurchFolderName")} style={linkStyle} onClick={() => hcContext.setUserWantsIsNavOpen(false)}>
                        <img style={{ marginLeft: 20 }} width='20px' src={hcContext.isDarkTheme ? image_sources_darkTheme : image_sources} alt="Bible" />
                        <span style={{ marginLeft: 20 }} className={navEltsClass}><GetHtmlStrLocalized language={language} textId="catechism" /></span>
                    </Link>
                    <Link to={"/" + language + "/" + GetStrLocalized(language, "readingsFolderName") + "/" + GetStrLocalized(language, "papalTextsFolderName")} style={linkStyle} onClick={() => hcContext.setUserWantsIsNavOpen(false)}>
                        <img style={{ marginLeft: 20 }} width='20px' src={hcContext.isDarkTheme ? image_sources_darkTheme : image_sources} alt="Bible" />
                        <span style={{ marginLeft: 20 }} className={navEltsClass}><GetHtmlStrLocalized language={language} textId="papalTexts" /></span>
                    </Link>
                    <Link to={"/" + language + "/" + GetStrLocalized(language, "sourcesFolderName")} style={linkStyle} onClick={() => hcContext.setUserWantsIsNavOpen(false)}>
                        <img style={{ marginLeft: 20 }} width='20px' src={hcContext.isDarkTheme ? image_sources_darkTheme : image_sources} alt="sources" />
                        <span style={{ marginLeft: 20 }} className={navEltsClass}><GetHtmlStrLocalized language={language} textId="sources" /></span>
                    </Link>
                    <Link to={"/" + language + "/" + GetStrLocalized(language, "tagsFolderName")} style={linkStyle} onClick={() => hcContext.setUserWantsIsNavOpen(false)}>
                        <img style={{ marginLeft: 20 }} width='20px' src={hcContext.isDarkTheme ? image_sources_darkTheme : image_sources} alt="tags" />
                        <span style={{ marginLeft: 20 }} className={navEltsClass}><GetHtmlStrLocalized language={language} textId="tags" /></span>
                    </Link>
                    <Link to={"/" + otherLanguage} style={linkStyle} onClick={() => { hcContext.setUserWantsIsNavOpen(false); setLanguage(otherLanguage); }}>
                        <img style={{ marginLeft: 20 }} width='20px' src={image_otherLanguageFlag} alt="flag" />
                        <span style={{ marginLeft: 20 }} className={navEltsClass}><GetHtmlStrLocalized language={language} textId="goToTheOtherLanguageVersion" /></span>
                    </Link>
                    <Link to={"/" + language + "/" + GetStrLocalized(language, "aboutFolderName")} style={linkStyle} onClick={() => hcContext.setUserWantsIsNavOpen(false)}>
                        <img style={{ marginLeft: 20 }} width='20px' src={hcContext.isDarkTheme ? image_profil_darkTheme : image_profil} alt="profil" />
                        <span style={{ marginLeft: 20 }} className={navEltsClass}><GetHtmlStrLocalized language={language} textId="about" /></span>
                    </Link>
                    {
                        hcContext.userAsRightsToModifyTheContent &&
                        <Link to={"/" + language + "/" + GetStrLocalized(language, "cmsFolderName")} style={linkStyle} onClick={() => hcContext.setUserWantsIsNavOpen(false)}>
                            <img style={{ marginLeft: 20 }} width='20px' src={hcContext.isDarkTheme ? image_manage_darkTheme : image_manage} alt="edit" />
                            <span style={{ marginLeft: 20 }} className={navEltsClass}><GetHtmlStrLocalized language={language} textId="cms" /></span>
                        </Link>
                    }
                </div>
                <br /><br /><br /><br /><br /><br />
            </div>
            <br />
        </>
    )
}

export default HCNavBar